import axios from '../axios';

const usersAPI = {
  getAll: async () => {
    const response = await axios.get('/users');
    return response.data;
  },

  create: async (userData) => {
    const response = await axios.post('/auth/create-office', userData);
    return response.data;
  },

  update: async (userId, userData) => {
    const response = await axios.put(`/users/${userId}`, userData);
    return response.data;
  },

  reinvite: async (userId) => {
    const response = await axios.post(`/auth/re-invite`, { userId });
    return response.data;
  },
};

export default usersAPI;

